import { useState, useEffect, useContext } from "react";
import axios from "axios";
import LoaderContext from "../Components/loader";


// Hook for fetching all data
export const useFetchAll = (fetchFunc) => {
  const [value, setValue] = useState([]);
  const { handleLoading } = useContext(LoaderContext);
  const [error, setError] = useState(null);
  // const [isCaching, setIsCaching] = useState(false);

  const fetchAllData = async () => {
    // if (isCaching) return;
    handleLoading(true);
    try {
      const response = await fetchFunc();

      
      setValue(response.data)
      // setIsCaching(true);
    } catch (err) {
      // console.log(err);
      setError(err);
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  },[]);

  return { value, error, fetchAllData };
};

// Hook for fetching single data by ID
export const useFetchSingle = (url, id) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${url}/${id}`);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, id]);

  return { data, loading, error };
};



// Hook for creating new data
export const useCreateData = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createData = async (newData) => {
    setLoading(true);
    try {
      const response = await axios.post(url, newData);
      setData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, createData };
};

// Hook for updating data by Id

export const useUpdateData = (url) => {
  const [dataUpdate, setDataUpdate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateData = async (id, updatedData) => {
    setLoading(true);
    try {
      const response = await axios.put(`${url}/${id}`, updatedData);
      setDataUpdate(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { dataUpdate, loading, error, updateData };
};


//Hook for Delete data using Id
export const DeleteDocumentData = (url) => {
  const [DeleteData, setDeleteData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteDocData = async (id, deleteData) => {
    setLoading(true);
    try {
      const response = await axios.delete(`${url}/${id}`, deleteData);
      setDeleteData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { DeleteData, loading, error, deleteDocData };
};